import actions from './actions';

const initState = {
  isCreating: false,
  isLoading: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_SHOP_MENU:
    case actions.CREATE_SHOP_MENU_SHOP_MERCHANDISES:
    case actions.CREATE_SHOP_BRAND_CONFIGURATION:
    case actions.CREATE_ADDITIONAL_SHOP_MERCHANDISE:
    case actions.CREATE_SHOP_POINT_DISCOUNT_RULE:
    case actions.CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_SHOP_MENU_ENDED:
    case actions.CREATE_SHOP_MENU_SHOP_MERCHANDISES_ENDED:
    case actions.CREATE_SHOP_BRAND_CONFIGURATION_ENDED:
    case actions.CREATE_ADDITIONAL_SHOP_MERCHANDISE_ENDED:
    case actions.CREATE_SHOP_POINT_DISCOUNT_RULE_ENDED:
    case actions.CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_SHOP_MENUS:
    case actions.SEARCH_SHOP_CATEGORIES:
    case actions.GET_SHOP_MAIN_CONFIGURATION:
    case actions.SEARCH_SHOP_BRAND_CONFIGURATIONS:
    case actions.SEARCH_ADDITIONAL_SHOP_MERCHANDISES:
    case actions.SEARCH_SHOP_MENU_SHOP_MERCHANDISES:
    case actions.SEARCH_SHOP_POINT_DISCOUNT_RULES:
    case actions.SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES:
    case actions.SEARCH_SHOP_MERCHANDISE_CATEGORIES:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_SHOP_MENUS_ENDED:
    case actions.SEARCH_SHOP_CATEGORIES_ENDED:
    case actions.GET_SHOP_MAIN_CONFIGURATION_ENDED:
    case actions.SEARCH_SHOP_BRAND_CONFIGURATIONS_ENDED:
    case actions.SEARCH_ADDITIONAL_SHOP_MERCHANDISES_ENDED:
    case actions.SEARCH_SHOP_MENU_SHOP_MERCHANDISES_ENDED:
    case actions.SEARCH_SHOP_POINT_DISCOUNT_RULES_ENDED:
    case actions.SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED:
    case actions.SEARCH_SHOP_MERCHANDISE_CATEGORIES_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_SHOP_MENU:
    case actions.UPDATE_SHOP_CATEGORIES:
    case actions.UPDATE_SHOP_MAIN_CONFIGURATION:
    case actions.UPDATE_SHOP_BRAND_CONFIGURATION:
    case actions.UPDATE_SHOP_POINT_DISCOUNT_RULE:
    case actions.UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY:
    case actions.UPDATE_SHOP_MERCHANDISE_CATEGORY:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_SHOP_MENU_ENDED:
    case actions.UPDATE_SHOP_CATEGORIES_ENDED:
    case actions.UPDATE_SHOP_MAIN_CONFIGURATION_ENDED:
    case actions.UPDATE_SHOP_BRAND_CONFIGURATION_ENDED:
    case actions.UPDATE_SHOP_POINT_DISCOUNT_RULE_ENDED:
    case actions.UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED:
    case actions.UPDATE_SHOP_MERCHANDISE_CATEGORY_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_SHOP_MENUS:
    case actions.DELETE_SHOP_MENU_SHOP_MERCHANDISES:
    case actions.DELETE_ADDITIONAL_SHOP_MERCHANDISES:
    case actions.DELETE_SHOP_POINT_DISCOUNT_RULES:
    case actions.DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES:
    case actions.DELETE_SHOP_MERCHANDISE_CATEGORIES:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_SHOP_MENUS_ENDED:
    case actions.DELETE_SHOP_MENU_SHOP_MERCHANDISES_ENDED:
    case actions.DELETE_ADDITIONAL_SHOP_MERCHANDISES_ENDED:
    case actions.DELETE_SHOP_POINT_DISCOUNT_RULES_ENDED:
    case actions.DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED:
    case actions.DELETE_SHOP_MERCHANDISE_CATEGORIES_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    case actions.CREATE_SALES_QUANTITY:
    case actions.SEARCH_SALES_QUANTITY:
    case actions.GET_SALES_QUANTITY:
    case actions.UPDATE_SALES_QUANTITY:
    case actions.DELETE_SALES_QUANTITY:
      return {
        ...state,
        isLoading: true,
      };
    case actions.CREATE_SALES_QUANTITY_ENDED:
    case actions.SEARCH_SALES_QUANTITY_ENDED:
    case actions.GET_SALES_QUANTITY_ENDED:
    case actions.UPDATE_SALES_QUANTITY_ENDED:
    case actions.DELETE_SALES_QUANTITY_ENDED:
      return {
        ...state,
        isLoading: false,
      };
    case actions.SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS:
    case actions.UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY:
    case actions.CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY:
    case actions.GET_SHOP_ORDER_EXTRA_COLUMN_KEY:
    case actions.DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY:
      return {
        ...state,
        isLoading: true,
      };
    case actions.SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS_END:
    case actions.UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END:
    case actions.CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END:
    case actions.GET_SHOP_ORDER_EXTRA_COLUMN_KEY_END:
    case actions.DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY_END:
      return {
        ...state,
        isLoading: false,
      };
    case actions.COPY_SHOP_MENU:
    case actions.COPY_SHOP_MENU_ENDED:
    default:
      return state;
  }
}
